import React from 'react';
import Service from "src/api/Service"
import { Button, Form, InputNumber, Input, Checkbox, Table, Select, Typography, Menu, Divider, Pagination } from 'antd';
import { Resizable } from "react-resizable";
import { FileTextTwoTone } from '@ant-design/icons';
import axios from 'axios';
import config from 'src/config';
import deleteIcon from "src/assets/images/error-close.png"

const GetColumnFilterProps = (dataIndex, props) => {
    let { currentPage, setCurrentPage, menuItems, SetmenuItems, TotalList, setFilterObject, OriginalData, setData, setLoading, showErrorNotification } = props
    const pageSize = 10; // Set your desired page size here
    let Rerender = false

    const onPageChange = (page) => {
        setCurrentPage((prev) => { return { ...prev, [dataIndex]: page } });
    };

    const startIdx = (currentPage[dataIndex] - 1) * pageSize;
    const endIdx = startIdx + pageSize;
    const paginatedList = Array.isArray(menuItems[dataIndex]) ? menuItems[dataIndex].slice(startIdx, endIdx) : [];
    // console.log(menuItems,paginatedList)
    return {
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
            return (
                <div style={{ padding: 8 }}>
                    <Input
                        placeholder="Search in filters"
                        onChange={(e) => {
                            let inputValue = e.target.value.toLowerCase(); // Convert to lowercase
                            let filteredList = TotalList[dataIndex].filter((item) => item.text.toLowerCase().includes(inputValue));
                            SetmenuItems((prev) => { return { ...prev, [dataIndex]: filteredList } }) // Update the filtered list
                        }}
                        id={"search" + dataIndex}
                    />
                    <Divider style={{ margin: 7 }} />
                    <Menu multiple={true} selectedKeys={selectedKeys} trigger={['click']}>
                        <Menu.Item key={"Select All"} onClick={() => {
                            if (selectedKeys.length == menuItems[dataIndex].length) {
                                setSelectedKeys([])
                            } else {
                                let newArray = menuItems[dataIndex].map((obj) => obj.value)
                                setSelectedKeys(newArray)
                            }
                        }
                        }>
                            {"Select All"}
                        </Menu.Item>
                        {paginatedList.map((item) => {
                            return (
                                <Menu.Item key={item.value} onClick={() => {
                                    let newArray = selectedKeys
                                    if (newArray.includes(item.value)) {
                                        newArray = newArray.filter(ele => ele !== item.value);
                                    } else {
                                        newArray.push(item.value)
                                    }
                                    setSelectedKeys(newArray)
                                }
                                }>
                                    {item.text}
                                </Menu.Item>
                            );
                        })}
                    </Menu>
                    <Divider style={{ margin: 7 }} />
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div>
                            <Button
                                type="link"
                                size="small"
                                disabled={selectedKeys.length > 0 ? false : true}
                                onClick={() => {
                                    setSelectedKeys([])
                                }}
                            >
                                Reset
                            </Button>
                        </div>
                        <div>
                            <Button
                                type="primary"
                                onClick={async () => {
                                    Rerender = true
                                    let filterObject = {}
                                    if (selectedKeys.length > 0) {
                                        setFilterObject((prev) => {
                                            filterObject = { ...prev, [dataIndex]: selectedKeys }
                                            return { ...prev, [dataIndex]: selectedKeys }
                                        })
                                    } else {
                                        setFilterObject((prev) => {
                                            const { [dataIndex]: removedKey, ...rest } = prev;
                                            filterObject = rest
                                            return rest;
                                        })
                                    }
                                    setLoading(true)
                                    SetmenuItems((prev) => { return { ...prev, [dataIndex]: TotalList[dataIndex] } })
                                    await GetFilterData(filterObject, OriginalData, props)
                                    confirm();
                                }}
                                size="small"
                            >
                                Ok
                            </Button>
                        </div>
                    </div>
                    <Pagination
                        current={currentPage[dataIndex]}
                        pageSize={pageSize}
                        simple
                        total={menuItems[dataIndex] ? menuItems[dataIndex].length : 100}
                        position={['none', 'bottomRight']}
                        defaultPageSize={20}
                        onChange={onPageChange}
                        style={{ marginTop: '8px', textAlign: 'right' }}
                    />
                </div>
            );
        },
        onFilter: (value, record) => {
            return true
        },
        onFilterDropdownOpenChange: (visible) => {
            if (Rerender) {
                Rerender = false
                setCurrentPage((prev) => { return { ...prev, [dataIndex]: 1 } })
            }
        }
    };
}


const GetFilterData = async (FilterObject, OriginalData, props) => {
    let { setData, setLoading, showErrorNotification } = props
    if (Object.keys(FilterObject).length > 0) {

        let filterObject = {}
        Object.entries(FilterObject).map(([key, value]) => {
            filterObject[key] = new Set(value)
        })

        let obj = {
            "data": OriginalData,
            "filterObject": FilterObject
        }

        await Service.post("filter/GetfilteredData", obj, (status, data) => {
            if (status == 200) {
                console.log(data)
                if (!data) {
                    setData([])
                    setLoading(false)
                    showErrorNotification("Failed to filter records. Please try again later.")
                } else {
                    setData(data)
                    setLoading(false)
                }
            }
        })
    } else {
        setData(OriginalData)
        setLoading(false)
    }

}

const GetStringValue = (ValA, ValB, remoteSourceA, remoteSourceB) => {
    if (Array.isArray(ValA)) {
        let StringA = ""
        let StringB = ""
        for (let val of ValA) {
            StringA += remoteSourceA[val]
        }
        for (let val of ValB) {
            StringB += remoteSourceB[val]
        }
        return StringA.localeCompare(StringB)
    } else {
        let StringA = remoteSourceA[ValA] ? remoteSourceA[ValA] : ValA
        let StringB = remoteSourceB[ValB] ? remoteSourceB[ValB] : ValB
        return StringA.localeCompare(StringB)
    }
}

const GetSorter = (a, b, key, props) => {
    let { fieldsToShow, dependent } = props
    if (a[key] && b[key]) {
        if (fieldsToShow[key]["remote-source"]) {
            return GetStringValue(a[key], b[key], fieldsToShow[key]["remote-source"], fieldsToShow[key]["remote-source"])
        } else if (fieldsToShow[key]['parent']) {
            let remoteSourceA = dependent[key + "-" + a[fieldsToShow[key]['parent']]]
            let remoteSourceB = dependent[key + "-" + b[fieldsToShow[key]['parent']]]
            return GetStringValue(a[key], b[key], remoteSourceA, remoteSourceB)
        } else if (fieldsToShow[key]['type'] === 'number' || typeof (a[key]) === 'number') {
            return a[key] - b[key]
        } else if (fieldsToShow[key]['type'] === 'text' || typeof (a[key]) === 'string') {
            return a[key].localeCompare(b[key])
        }
    } else if (a[key]) {
        return 1
    } else {
        return -1
    }
}

const handleResize = (index, props) => (e, { size }) => {
    let { setColumns } = props
    setColumns((prevColumns) => {
        const nextColumns = [...prevColumns];
        nextColumns[index] = {
            ...nextColumns[index],
            width: size.width,
        };
        return nextColumns;
    });
}

const handleCellChange = (key, props) => {
    let keysArray = props.UpdatedColumnKeys
    if (!keysArray.includes(key)) {
        keysArray.push(key)
        props.setUpdatedColumnKeys(keysArray)
    }
    console.log(keysArray)
}

const ResetChilds = (child, record, props) => {
    let { form } = props
    if (Array.isArray(child)) {
        for (let ch of child) {
            form.setFieldValue([ch + "-" + record['key']], props.fieldsToShow[ch]['selectMode'] == "multiple" ? [] : null)
            let field = props.fieldsToShow[ch]
            if (field['child']) {
                ResetChilds(field['child'], record, props)
            }
        }
    } else {
        form.setFieldValue([child + "-" + record['key']], props.fieldsToShow[child]['selectMode'] == "multiple" ? [] : null)
        let field = props.fieldsToShow[child]
        if (field['child']) {
            ResetChilds(field['child'], record, props)
        }
    }
}

const EditableCell = React.memo(({
    editing,
    dataIndex,
    handleDependent,
    title,
    inputType,
    required,
    source,
    selectMode,
    remoteSource,
    record,
    min,
    max,
    index,
    children,
    Key,
    props,
    openFile,
    setOpenFile,
    setModalContent,
    colorSetField ,
    ...restProps
}) => {
    let { form, dependent } = props ? props : {}

    const inputNode = inputType === 'number' ? <InputNumber id={dataIndex + "-" + Key} min={min ? min : null} max={max ? max : null} onChange={(e) => { handleCellChange(record['key'], props) }} /> : <Input id={dataIndex + "-" + Key} onChange={(e) => { handleCellChange(record['key'], props) }} />;

    if (inputType == 'date') {
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item
                        name={dataIndex + "-" + record['key']}
                        initialValue={record ? record[dataIndex] : null}
                        rules={[
                            {
                                message: "Please provide valid " + title,
                                required: required
                            },
                        ]}

                    >
                        <input id={dataIndex + "-" + Key} type="date" className='form-control ant-input' onChange={(e) => { handleCellChange(record['key'], props) }} />
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    }
    else if (inputType == 'number' || inputType == 'text' || inputType == 'email') {
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item
                        name={dataIndex + "-" + record['key']}
                        initialValue={record ? record[dataIndex] : null}
                        style={{
                            margin: 0,
                        }}
                        rules={[
                            {

                                required: required,
                                message: "Please provide valid " + title
                            },
                        ]}
                    >
                        {inputNode}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    } else if (inputType == 'select') {
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item
                        name={dataIndex + "-" + record['key']}
                        initialValue={record ? record[dataIndex]?.toLocaleString() : null}
                        rules={[{ required: required, message: "Please provide valid " + title }]}
                    >
                        <Select showSearch dropdownStyle={{ zIndex: 1 }} getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            filterOption={(input, option) => option.SearchText.toLowerCase().includes(input.toLocaleLowerCase())} mode={selectMode} style={{ width: '100%' }} id={dataIndex + "-" + Key} onChange={(e) => { handleCellChange(record['key'], props) }} >
                            {
                                source ? source.map((val, index) => {
                                    return <Select.Option key={val} SearchText={val} value={val}>{val}</Select.Option>
                                }) : ""
                            }
                        </Select>
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    } else if (inputType == 'selectMultiple') {
        let val = '';
        Object.keys(remoteSource).forEach((key) => {
            // Check if record[dataIndex] exists and is an array
            if (Array.isArray(record[dataIndex])) {
                record[dataIndex].forEach((ele) => {
                    if (ele === key) {
                        val += remoteSource[key] + ',';
                    }
                });
            }
        });

        // console.log(val)
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item
                        name={dataIndex + "-" + record['key']}
                        initialValue={record && record[dataIndex] ? record[dataIndex] : []}
                        rules={[{ required: required, message: "Please provide valid " + title }]}
                    >
                        <Select showSearch getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            filterOption={(input, option) => option.SearchText.toLowerCase().includes(input.toLocaleLowerCase())} mode={selectMode} style={{ width: '100%' }} maxTagCount='responsive' onChange={(value) => {
                                if (value.includes("Select All")) {
                                    let AllValues = Object.keys(remoteSource).map((key, index) => key)
                                    value.length === Object.keys(remoteSource).length + 1 ? form.setFieldValue([dataIndex + "-" + record['key']], []) : form.setFieldValue(dataIndex + "-" + record['key'], AllValues)
                                }
                                handleCellChange(record['key'], props)
                            }}
                            id={dataIndex + "-" + Key}
                            allowClear={true} >
                            <Select.Option key={"Select All"} SearchText={"Select All"} value={"Select All"}>Select All</Select.Option>
                            {

                                Object.keys(remoteSource).map((key, index) => {
                                    return <Select.Option key={index} SearchText={remoteSource[key]} value={key}>{remoteSource[key]} </Select.Option>
                                })
                            }
                        </Select>
                    </Form.Item>
                ) : (
                    val.substring(0, val.length - 1)
                )}
            </td>
        );
    } else if (inputType == 'select2') {
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item
                        name={dataIndex + "-" + record['key']}
                        initialValue={record ? record[dataIndex]?.toLocaleString() : null}
                        rules={[{ required: required, message: "Please provide valid " + title }]}
                    >
                        <Select showSearch getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            filterOption={(input, option) => option.SearchText.toLowerCase().includes(input.toLocaleLowerCase())} mode={selectMode} style={{ width: '100%' }} maxTagCount='responsive' allowClear={true} id={dataIndex + "-" + Key} onChange={(e) => { handleCellChange(record['key'], props) }} >
                            {
                                Object.keys(remoteSource).map((key, index) => {
                                    return <Select.Option SearchText={remoteSource[key]} className={index + dataIndex} key={index} value={key + ""}>{remoteSource[key]} </Select.Option>
                                })
                            }
                        </Select>
                    </Form.Item>
                ) : (
                    remoteSource[record[dataIndex]]
                )}
            </td>
        );
    } else if (inputType == 'dependent') {
        if (!props || !props.fieldsToShow[dataIndex]) {
            return inputNode
        } else if (props.fieldsToShow[dataIndex]['parent']) {
            let parentValue = form.getFieldValue(props.fieldsToShow[dataIndex]['parent'] + "-" + record['key'])
            let remote_source = dependent[dataIndex + "-" + parentValue] ? dependent[dataIndex + "-" + parentValue] : {}
            return (
                <td {...restProps}>
                    {editing ? (
                        <Form.Item
                            name={dataIndex + "-" + record['key']}
                            initialValue={record ? record[dataIndex] : null}
                            rules={[{ required: required, message: "Please provide valid " + title }]}
                        >
                            <Select showSearch getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                filterOption={(input, option) => option.SearchText.toLowerCase().includes(input.toLocaleLowerCase())} mode={selectMode} onDeselect allowClear={true}
                                onChange={(e) => {
                                    let field = dataIndex
                                    if (props.fieldsToShow[field]['child']) {
                                        ResetChilds(props.fieldsToShow[field]['child'], record, props)
                                    }
                                    // let child = props.fieldsToShow[dataIndex]['child']
                                    // child ? form.setFieldValue([child + "-" + record['key']], null) : ""
                                    if (selectMode === "multiple" && e.includes("Select All")) {
                                        let AllValues = Object.keys(remote_source).map((key, index) => key)
                                        e.length === Object.keys(remote_source).length + 1 ? form.setFieldValue([dataIndex + "-" + record['key']], []) : form.setFieldValue(dataIndex + "-" + record['key'], AllValues)
                                    }

                                    selectMode !== "multiple" ? handleDependent(e, dataIndex, props) : null
                                    handleCellChange(record['key'], props)
                                }}

                                id={dataIndex + "-" + Key}
                                style={{ width: '100%' }} maxTagCount='responsive' >
                                {selectMode === "multiple" ? <Select.Option key={"Select All"} SearchText={"Select All"} value={"Select All"}>Select All</Select.Option> : null}
                                {
                                    Object.keys(remote_source).map((key, index) => {
                                        return <Select.Option key={index} SearchText={remote_source[key]} value={key + ""}>{remote_source[key]} </Select.Option>
                                    })
                                }
                            </Select>
                        </Form.Item>
                    ) : (
                        remote_source[record[dataIndex]]
                    )}
                </td>
            );
        } else {

            return (
                <td {...restProps}>
                    {editing ? (
                        <Form.Item
                            name={dataIndex + "-" + record['key']}
                            initialValue={record ? record[dataIndex] : null}
                            rules={[{ required: required, message: "Please provide valid " + title }]}
                        >
                            <Select showSearch getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                filterOption={(input, option) => option.SearchText.toLowerCase().includes(input.toLocaleLowerCase())} mode={selectMode} allowClear={true}
                                onChange={(e) => {
                                    let field = dataIndex
                                    if (props.fieldsToShow[field]['child']) {
                                        ResetChilds(props.fieldsToShow[field]['child'], record, props)
                                    }
                                    // let child = props.fieldsToShow[dataIndex]['child']
                                    // child ? form.setFieldValue([child + "-" + record['key']], null) : ""
                                    handleDependent(e, dataIndex, props)
                                    handleCellChange(record['key'], props)
                                }}
                                id={dataIndex + "-" + Key}
                                style={{ width: '100%' }} maxTagCount='responsive' >
                                {
                                    Object.keys(remoteSource).map((key, index) => {
                                        return <Select.Option key={index} SearchText={remoteSource[key]} value={key}>{remoteSource[key]} </Select.Option>
                                    })
                                }
                            </Select>
                        </Form.Item>
                    ) : (
                        remoteSource[record[dataIndex]]
                    )}
                </td>
            );
        }

    } else if (inputType == 'dateTime') {

        const inputDate = new Date(record[dataIndex]);

        // Get the current time zone offset in minutes
        const currentTimeZoneOffsetMinutes = inputDate.getTimezoneOffset();

        // Calculate the local time by applying the offset
        const localTime = new Date(inputDate.getTime() - (currentTimeZoneOffsetMinutes * 60 * 1000));

        // Format the local time in a user-readable format
        const formattedLocalTime = localTime.toLocaleString();
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item
                        name={dataIndex + "-" + record['key']}
                        initialValue={record ? record[dataIndex] : null}
                        style={{
                            margin: 0,
                        }}
                        rules={[
                            {
                                message: "Please provide valid " + title,
                                required: required
                            },
                        ]}
                    >
                        {inputNode}
                    </Form.Item>
                ) : (
                    formattedLocalTime
                )}
            </td>)

    } else if (inputType == 'file') {
        return (
            <td {...restProps} style={{ textAlign: "center" }}>
                <FileTextTwoTone twoToneColor={record[colorSetField]  ? "#FF7E7E" : "#60D299"}
                    onClick={() => {
                        downloadFile(record[dataIndex])
                    }}
                />
            </td>
        );
    } else {
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item
                        name={dataIndex + "-" + record['key']}
                        initialValue={record ? record[dataIndex] : null}
                        style={{
                            margin: 0,
                        }}
                        rules={[
                            {
                                message: "Please provide valid " + title,
                                required: required
                            },
                        ]}
                    >
                        {inputNode}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    }

})

const downloadFile = async (FilePath) => {
  
    try {

      let body = {filePath : FilePath}
      const response = await axios.post(`${config[process.env.REACT_APP_ENVIRONMENT].apiUrl}/saddlepointtech/exceptionLog`,body, {
        responseType: 'arraybuffer',
      })
  
      console.log(response)

      const fileName = 'exception_logs'
  
      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    } catch (error) {
      console.error('Error downloading file:', error.message);
      // Handle the error, e.g., show an error message to the user
    }
  }

const handleDependent = async (value, fieldName, props) => {
    let { fieldsToShow, dependent, setDependent, tabname } = props
    if (value) {
        const fieldConfig = fieldsToShow[fieldName];
        const dependentField = fieldConfig['child'];
        if (!dependentField) return;
        try {
            if (Array.isArray(dependentField)) {
                dependentField.map(async (field) => {

                    if (fieldsToShow[field]['path'] != undefined) {
                        var new_dependentField = fieldsToShow[field]['path'];
                    } else {
                        var new_dependentField = field;
                    }

                    let fieldname = field + "-" + value
                    !dependent[fieldname] ? await Service.get(new_dependentField + "/" + value + "/" + tabname, (status, data) => {
                        // console.log(data)
                        if (status == 200) {
                            setDependent((prevState) => {
                                return { ...prevState, [fieldname]: data };
                            })
                        }
                    }) : ''
                })

            } else {

                if (fieldsToShow[dependentField]['path'] != undefined) {
                    var new_dependentField = fieldsToShow[dependentField]['path'];
                } else {
                    var new_dependentField = dependentField;
                }

                let remote_source = fieldsToShow[fieldName];
                let child_fieldName = remote_source['child'];
                // Update the state with the new key-value pair
                let fieldname = child_fieldName + "-" + value

                !dependent[fieldname] ? await Service.get(new_dependentField + "/" + value + "/" + tabname, (status, data) => {
                    if (status == 200) {
                        setDependent((prevState) => {
                            return { ...prevState, [fieldname]: data };
                        })
                    }
                }) : ''
            }

        } catch (error) {
            console.error("Error fetching data for the child dropdown:", error);
        }
    } else {
        let remote_source = fieldsToShow[fieldName];
        let child_fieldName = remote_source['child'];

        if (Array.isArray(child_fieldName)) {
            child_fieldName.map((child) => {
                let fieldname = child + "-" + value
                !dependent[fieldname] ? setDependent((prevState) => {
                    return { ...prevState, [fieldname]: {} };
                }) : ''
            })
        } else {
            let fieldname = child_fieldName + "-" + value
            !dependent[fieldname] ? setDependent((prevState) => {
                return { ...prevState, [fieldname]: {} };
            }) : ''
        }

    }

}

const handleAdd = (action, props) => {
    if (action === 'AddRow') {
        props.showSuccessNotification('One row has been added to the top of the table');
        const newData = {}
        Object.entries(props.fieldsToShow).forEach(([key, value]) => {
            props.form.resetFields([key + "--1"])
            if (value['selectMode'] == "multiple") {
                newData[key] = []
            } else {
                newData[key] = ''
            }
        })
        newData['key'] = -1
        edit(newData, props)
        props.setData([newData, ...props.data]);
        props.setRowAdded(true)
    } else {
        handleDelete({ key: -1 }, props)
    }

}

const handleDelete = async (DeletedRecord, props) => {
    let deletedArray = props.DeletedColumnKeys
    let { setData, setDeletedColumnKeys, setRowAdded, data } = props
    let Data = data.filter((obj) => !deletedArray.includes(obj['key']) && obj['key'] !== DeletedRecord['key']);

    setData(Data)

    if (!deletedArray.includes(DeletedRecord['key'])) {
        deletedArray.push(DeletedRecord['key'])
        setDeletedColumnKeys(deletedArray)
    }

    if (DeletedRecord.key < 0) {
        setRowAdded(false)
    }

};

const edit = (record, props) => {

    Object.entries(props.fieldsToShow).forEach(([key, value], index) => {
        if (value.type == 'dependent' && value.child) {
            handleDependent(record[key], key, props)
        }
    })

    props.form.setFieldsValue({
        ...record,
    });

}

const save = async (props) => {
    try {

        let { DeletedColumnKeys, UpdatedColumnKeys, showInfoNotification,
            showSuccessNotification, form, OriginalData, showErrorNotification,
            FilterObject, parentId, currentParentId } = props

        let deletedColumnKeys = DeletedColumnKeys
        let updatedColumnKeys = UpdatedColumnKeys.filter((key) => !deletedColumnKeys.includes(key))

        console.log(updatedColumnKeys, deletedColumnKeys)
        if (updatedColumnKeys.length === 0 && deletedColumnKeys.length === 0) {
            showInfoNotification("No updates detected.")
        } else {
            const validation = await form.validateFields();

            let formValues = form.getFieldsValue()

            let errorMessage = null
            let successMessage = null

            for (let index of updatedColumnKeys) {
                let row = {}
                let record = {}
                index >= 0 ? OriginalData.filter((obj) => {
                    if (obj['key'] == index) {
                        record = obj
                    }
                }) : record['key'] = -1

                console.log(record, index)
                Object.entries(props.fieldsToShow).forEach(([key, value]) => {
                    const keyToRetrieve = `${key}-${index}`;
                    if (formValues.hasOwnProperty(keyToRetrieve)) {
                        row[key] = formValues[keyToRetrieve]
                    }
                })

                Object.entries(row).forEach(([key, value]) => {
                    if (Array.isArray(value)) {
                        if (value[0] ? value[0] === '' : false) {
                            value.shift()
                        }
                        row[key] = JSON.stringify(value)
                    }
                })

                //non edited array values 
                Object.entries(record).forEach(([key, value]) => {
                    if (Array.isArray(value)) {
                        record[key] = JSON.stringify(value)
                    }
                })

                console.log({ ...record, ...row })

                // Save changes in DB
                if (record.key < 0) {
                    let obj = { ...record, ...row }
                    // Add record
                    obj['createdOn'] = new Date()
                    obj['modifiedOn'] = new Date()
                    obj['clientid']= props.client_id;
                    obj['moduleId']=props.module_id;

                    if (parentId && currentParentId) {
                        obj[parentId] = parseInt(currentParentId)
                    }

                    await Service.post(props.module + "/" + props.tabname, obj, (status, data) => {
                        console.log(data)
                        if (status == 200) {
                            if (!data) {
                                errorMessage = "Failed to update records. Please try again later."
                            } else {
                                if (data['statusCodeValue'] && data['statusCodeValue'] != 200) {
                                    errorMessage = data['body']
                                } else {
                                    successMessage = "Data updated successfully."
                                }
                            }
                        }
                    });

                } else {
                    let obj = { ...record, ...row }
                    obj['createdOn'] = new Date()
                    obj['modifiedOn'] = new Date()
                    // update existing record
                    await Service.put(props.module + "/" + props.tabname, obj, (status, data) => {
                        if (status == 200) {
                            if (!data) {
                                errorMessage = "Failed to update records. Please try again later."
                            } else {
                                if (data['statusCodeValue'] && data['statusCodeValue'] != 200) {
                                    errorMessage = data['body']
                                } else {
                                    successMessage = "Data updated successfully."
                                }
                            }
                        }
                    });

                }
            }


            for (let index of deletedColumnKeys) {

                let DeletedRecord = {}
                OriginalData.filter((obj) => {
                    if (obj['key'] == index) {
                        DeletedRecord = obj
                    }
                })

                console.log(DeletedRecord)
                if (DeletedRecord.key >= 0) {

                    Object.entries(DeletedRecord).forEach(([key, value]) => {
                        if (Array.isArray(value)) {
                            if (value[0] ? value[0] === '' : false) {
                                value.shift()
                            }
                            DeletedRecord[key] = JSON.stringify(value)
                        }
                    })


                    await Service.delete(props.module + "/" + props.tabname, DeletedRecord, (status, data) => {
                        if (status == 200) {
                            if (!data) {
                                errorMessage = "Failed to update records. Please try again later."
                            } else {
                                successMessage = "Data updated successfully."
                            }
                        }
                    })
                }
            }

            if (errorMessage) {
                showErrorNotification(errorMessage)
            } else if (successMessage) {
                showSuccessNotification(successMessage)
                GetNewData(FilterObject, props)
            }
        }


    } catch (errInfo) {
        console.log('Validate Failed:', errInfo);
        let { showInfoNotification } = props
        showInfoNotification("Please fill in all required fields.")
    }
}

const GetStringified = (data) => {
    if (data) {
        let str = data.join(',');
        return str.substring(0, str.length - 1)
    } else {
        return ""
    }
}

const ResizeableTitle = ({ onResize, width, ...restProps }) => {
    if (!width) {
        return <th {...restProps} />;
    }

    return (
        <Resizable
            width={width}
            height={0}
            onResize={onResize}
            draggableOpts={{ enableUserSelectHack: false }}
        >
            <th {...restProps} />
        </Resizable>
    );
}

const GetNewData = async (FilterObject, props) => {
    try {
        let {
            showErrorNotification, setData, uniqueKey,
            setOriginalData, setuniqueKey, setLoading, setRowAdded,
            setUpdatedColumnKeys, setDeletedColumnKeys,  parentId, currentParentId } = props

        // let url = (parentId && currentParentId) ? props.module + "/" + props.tabname + "/" + parentId + "/" + currentParentId : props.module + "/" + props.tabname

        await Service.get("/kpiDashboard/config/"+
        props.client_id+"/"+
        props.module_id, (status, data) => {
            if (status == 200) {
                if (!data) {
                    showErrorNotification("Failed to fetch records. Please try again later.")
                    setData([])
                } else {
                    let increment = uniqueKey + 1
                    const Data = data.map((obj, index) => {
                        let record = {}
                        Object.entries(obj).forEach(([key, value]) => {
                            if (props.fieldsToShow[key] && props.fieldsToShow[key]['selectMode'] == "multiple" && value) {
                                const cleanedString = value.replace(/\\/g, '');
                                record[key] = JSON.parse(cleanedString)

                            } else {
                                if (props.fieldsToShow[key]) {
                                    if (props.fieldsToShow[key]['selectMode'] == "multiple") {
                                        record[key] = []
                                    } else {
                                        record[key] = value ? value + "" : value
                                    }
                                } else {
                                    record[key] = value
                                }
                            }
                        })
                        record['key'] = index + uniqueKey
                        increment = index + uniqueKey
                        return record
                    })
                    GetColumns(Data, props)
                    setOriginalData(Data)
                    setuniqueKey(increment + 1)

                    if (Object.keys(FilterObject).length > 0) {
                        setLoading(true)
                        GetFilterData(FilterObject, Data, props)
                    } else {
                        setData(Data)
                    }
                }

                setRowAdded(false)
                setUpdatedColumnKeys([])
                setDeletedColumnKeys([])
            }
        })
        
    } catch (er) {
        console.log(er)
    }
}

const GetFilterList = (data, key, remoteSource, props) => {
    let valuesList = []
    let duplicateKeysList = []
    let { dependent, fieldsToShow } = props
    data.filter((obj) => {
        if (fieldsToShow[key]['parent']) {
            if (!duplicateKeysList.includes(obj[key])) {
                valuesList.push(obj['key'])
                duplicateKeysList.push(obj[key])
            }
        } else if (obj[key] !== undefined && obj[key] !== null && obj[key] != "") {
            valuesList.push(obj[key])
        }
    })
    valuesList = new Set(valuesList)
    const filterList = []
    Array.from(valuesList).filter((val) => {
        if (fieldsToShow[key]['parent']) {
            let object = data.find((obj) => obj['key'] === val)
            let source = dependent[key + "-" + object[fieldsToShow[key]['parent']]]
            if (source && source[object[key]] && object[key]) {
                filterList.push({
                    text: source ? source[object[key]] : val,
                    value: object[key] + ''
                })
            }
        } else {
            filterList.push({
                text: remoteSource && remoteSource[val] ? remoteSource[val] : val,
                value: val + ''
            })
        }
    })

    return filterList
}


const GetColumns = (data, props) => {
    let columns = []
    let { setColumns ,FilterObject ,permission, tabname  } = props

    Object.entries(props.fieldsToShow).forEach(([key, value]) => {
        if (value.type != "hidden" || value.visible) {
            columns.push({
                title: value.label,
                dataIndex: key,
                align:'center',
                editable: value.editable,
                width: value.width ? parseInt(value.width) : 200,
                selectMode: value.selectMode ? value.selectMode : 'single',
                remoteSource: value['remote-source'] ? value['remote-source'] : {},
                type: value.type,
                filteredValue: FilterObject[key] || null,
                min: value.min,
                max: value.max,
                colorSetField : value.colorSetField , //for color of a file
                required: value.required ? true : false,
                source: value.source,
                sorter: (a, b) => GetSorter(a, b, key, props),
                filters: value['selectMode'] == "multiple" ? '' : value['remote-source'] ? GetFilterList(data, key, value['remote-source'], props) : GetFilterList(data, key, {}, props),
                filterSearch: true,
                // onFilter: (value, record) => {
                //     console.log(value, record)
                //     return record[key] != null || record[key] != undefined ? (record[key] + "").includes(value) : ''
                // },
                ellipsis: true ? null : {
                    showTitle: true,
                },
                render: (_, record) => {
                    if (Array.isArray(record[key])) {
                        const ele = GetStringified(record[key])
                        return ele
                    }
                    else {
                        return record[key]
                    }
                },
                ...value['selectMode'] == "multiple" ? {} : GetColumnFilterProps(key, props)
            })
        }

    })

    
        columns.push(
            {
                title: 'DELETE',
                dataIndex: 'operation',
                width: '35px',
                align: 'center',
                // fixed: 'right',
                render: (_, record) => {
                    return (

                        <>
                            <p className="btn btn-sm text-danger" data-toggle="tooltip" title="Remove" >
                            <img 
                            src={deleteIcon} onClick={() => {
                                                                handleDelete(record, props)
                                                            }}></img>
                               </p>
                        </>

                    ) 
                }
            },
        )
    
    setColumns(columns)
}

const HandleRefresh = (props) => {
    let { setFilterObject  } = props
    setFilterObject({})
    GetNewData({}, props)
}

const GetRecordsOfParent = async (parentId, props) => {
    let {
        setTableKey, setFilterObject, setData, setOriginalData,
        setuniqueKey, setRowAdded, setUpdatedColumnKeys,
        setDeletedColumnKeys, showErrorNotification, setcurrentParentId,
        uniqueKey } = props
        console.log("called")
    // setTableKey((prev) => { return prev + 1 })
    setFilterObject({})
    await Service.get(props.module + "/" + props.tabname + "/" + props.parentId + "/" + parentId, (status, data) => {
        if (status == 200) {
            if (data) {
                let increment = uniqueKey + 1
                const Data = data.map((obj, index) => {
                    let record = {}
                    Object.entries(obj).forEach(([key, value]) => {
                        if (props.fieldsToShow[key] && props.fieldsToShow[key]['type'] == "selectMultiple" && value) {
                            const cleanedString = value.replace(/\\/g, '');
                            record[key] = JSON.parse(cleanedString)

                        } else {
                            record[key] = value ? value + "" : value
                        }

                        if (props.fieldsToShow[key] && props.fieldsToShow[key]['parent']) {
                            handleDependent(obj[props.fieldsToShow[key]['parent']], props.fieldsToShow[key]['parent'], props)
                        }

                    })
                    record['key'] = index + uniqueKey
                    increment = index + uniqueKey
                    return record
                })

                GetColumns(Data, props)
                setData(Data)
                setOriginalData(Data)
                setuniqueKey(increment + 1)
                setRowAdded(false)
                setUpdatedColumnKeys([])
                setDeletedColumnKeys([])
            } else {
                showErrorNotification("Failed to fetch records. Please try again later.")
                setData([])
            }
        }
    });

    setcurrentParentId(parentId)
}



export {
    GetColumnFilterProps, GetFilterData, GetStringValue, GetNewData, GetColumns, GetFilterList,
    GetSorter, handleResize, handleCellChange, EditableCell, ResetChilds, HandleRefresh,
    handleDependent, handleAdd, handleDelete, edit, save, GetStringified, ResizeableTitle,
    GetRecordsOfParent
}